import React from 'react';
import { motion } from 'framer-motion';
import { RevealText } from './common/RevealText';
import Container from './common/Container';
import { Compass, PenTool, Hammer, Key } from 'lucide-react';

const Process = () => {
    const steps = [
        {
            icon: <Compass />,
            title: "Planning & Design",
            description: "We start with comprehensive planning and innovative architectural designs that maximize space and functionality."
        },
        {
            icon: <PenTool />,
            title: "Material Selection",
            description: "Only premium, certified materials are selected to ensure longevity and aesthetic appeal of your home."
        },
        {
            icon: <Hammer />,
            title: "Construction",
            description: "Our skilled workforce executes the plan with precision, adhering to strict safety and quality standards."
        },
        {
            icon: <Key />,
            title: "Timely Handover",
            description: "We take pride in our track record of delivering projects on time, ensuring you step into your dream home as promised."
        }
    ];

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.2,
                delayChildren: 0.1
            }
        }
    };

    const itemVariants = {
        hidden: { opacity: 0, y: 30 },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.8,
                ease: [0.22, 1, 0.36, 1]
            }
        }
    };

    return (
        <section className=" py-10 md:py-12 lg:py-16 xl:py-20  bg-surface relative overflow-hidden">
            {/* Background Decor */}
            <div className="absolute left-0 top-1/2 -translate-y-1/2 w-[300px] h-[300px] bg-secondary/5 rounded-full blur-[80px] pointer-events-none" />

            <Container className="relative z-10">
                <motion.div
                    variants={containerVariants}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, margin: "-100px" }}
                >
                    <div className="text-center mb-16">
                        <motion.span
                            variants={itemVariants}
                            className="text-secondary font-bold tracking-wider uppercase text-sm"
                        >
                            Workflow
                        </motion.span>
                        <motion.h2
                            variants={itemVariants}
                            className="mt-2 text-3xl md:text-5xl font-serif text-primary font-bold"
                        >
                            <RevealText className='justify-center' text="Our Construction Process" />
                        </motion.h2>
                        <div className="mt-4 mx-auto w-24 h-1 bg-secondary" style={{ width: "96px" }}></div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 relative">
                        {/* Connecting Line (Desktop) */}
                        <div className="hidden lg:block absolute top-[45px] left-[10%] right-[10%] h-[2px] bg-secondary/20 -z-10" />

                        {steps.map((step, index) => (
                            <>
                                <motion.div
                                    key={index}
                                    variants={itemVariants}
                                    whileHover={{ y: -10 }}
                                    className="group flex flex-col items-center border-2 border-secondary/20 text-center p-6 bg-white rounded-lg shadow-sm hover:shadow-xl transition-all duration-300 relative"
                                >
                                    <div className=" lg:w-24 lg:h-24 w-16 h-16 rounded-full bg-surface border-4 border-white shadow-lg flex items-center justify-center mb-6 group-hover:scale-110 group-hover:border-secondary/50 transition-all duration-300 z-10 text-secondary">
                                        {step.icon}
                                    </div>
                                    {/* <h3 className="text-xl font-bold text-primary mb-3">
                                        {step.title}
                                    </h3> */}
                                    <h3 className="mb-2 lg:mb-3 text-md md:text-lg lg:text-xl  font-bold text-primary transition-colors">
                                        {step.title}
                                    </h3>
                                    <p className="text-secondary leading-relaxed text-sm md:text-md lg:text-lg">
                                        {step.description}
                                    </p>
                                </motion.div>

                                {/* <motion.div
                                    key={index}
                                    variants={itemVariants}
                                    whileHover={{ y: -10 }}
                                    className="justify-center items-center flex flex-col md:items-start group md:p-6 p-4 lg:p-8 bg-surface rounded-lg border border-gray-100 shadow-sm hover:shadow-xl hover:border-secondary/30 transition-all duration-300"
                                >
                                    <div className="mb-4 lg:mb-6  text-secondary group-hover:scale-110 transition-transform duration-300">
                                        {service.icon}
                                    </div>
                                    <h3 className="mb-2 lg:mb-3 text-md md:text-lg lg:text-xl  font-bold text-primary transition-colors">
                                        {service.title}
                                    </h3>
                                    <p className="text-secondary leading-relaxed text-sm md:text-md lg:text-lg">
                                        {service.description}
                                    </p>
                                </motion.div> */}
                            </>
                        ))}
                    </div>
                </motion.div>
            </Container>
        </section>
    );
};

export default Process;
